<template>
</template>

<script>
export default {
    name: 'iframeview',
    data(){
        return {
        }
    },
    created(){
    },
    activated(){
        console.log('iframeweb---',this.$route)
    }
}
</script>

<style scoped lang = "less">
.ifr{
    width:100%;
    height:100%;
    border:none;
}
</style>